import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.scss';
import './designEtatSurchage.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from 'components/Helpers/ScrollToTop';
import IndexPage from './pages';
import reportWebVitals from './reportWebVitals';
import store from './store';
import './security/relAttributeHandler';

const app = document.getElementById('root');
const root = createRoot(app);

// render app to root
root.render(
    <Provider store={store}>
        <Router>
            <ScrollToTop />
            <IndexPage />
        </Router>
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
